import React, { useState, useEffect } from 'react'
import { keyframes, css } from 'styled-components'
import PropTypes from 'prop-types'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Spinner = ({ size = 40, color = '#062041' }) => {
  if (typeof size !== 'number') {
    size = 40
  }

  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), 200)

    return () => clearTimeout(timer)
  })

  return (
    <div css={{ display: showSpinner ? 'flex' : 'none' }}>
      <div
        role='progressBar'
        css={css`
                display: inline-block;
                width: ${size}px;
                height: ${size}px;
                border-radius: ${size}px;
                border-top: 2px solid ${color};
                border-right: 2px solid ${color};
                border-bottom: 2px solid transparent;
                border-left: 2px solid transparent;
                animation: ${rotate} 0.65s linear infinite;
            `}
      />
    </div>
  )
}

Spinner.propTypes = {
  size: PropTypes.number
}

export { Spinner }
